/* eslint-disable no-console */

import * as Sentry from "@sentry/browser";

import {
  RAVEN_DSN,
  ENABLE_SENTRY_REPORTING,
  ENVIRONMENT,
  GIT_COMMIT,
} from "config/constants";

export default class Log {
  static setup() {
    // getCurrentHub().getClient() was pulled from https://github.com/getsentry/sentry-go/issues/9
    // as a check to see whether sentry has been initialized or not.
    if (
      ENABLE_SENTRY_REPORTING &&
      Sentry.getCurrentHub() &&
      !Sentry.getCurrentHub().getClient()
    ) {
      Sentry.init({
        dsn: RAVEN_DSN,
        environment: ENVIRONMENT,
        release: GIT_COMMIT,
        ignoreErrors: [
          "Network request failed", // Ignore network failures on Chrome
          "NetworkError when attempting to fetch resource", // ditto on Firefox
          "Failed to execute 'send' on 'XMLHttpRequest'", // ditto for our sync unlocker,
          "ResizeObserver loop completed with undelivered notifications",
          "AbortError",
          "Cannot read property 'getIn' of undefined",
        ],
      });
    }
  }

  static setUserContext(user) {
    if (ENABLE_SENTRY_REPORTING) {
      this.setup();
      Sentry.setExtra("email", user.email);
    }
  }

  /**
   * Log an error to Sentry
   * @param {*} msg - Error message or instance
   * @param {String} level - severity
   * @param {Object} extra - supplemental data to pass to Sentry
   * @param {Boolean} toConsole - true if this error should be logged to the console as well.
   * @param {Array<String>} fingerprint - see https://docs.sentry.io/learn/rollups/#customize-grouping-with-fingerprints
   */
  static logger(msg, level, extra, toConsole = true, fingerprint) {
    if (ENABLE_SENTRY_REPORTING) {
      this.setup();
      Sentry.captureException(msg, {
        level,
        fingerprint,
        extra: {
          ...extra,
          ...msg.context, // API errors return a special kind of error with lots of context
        },
      });
    }

    if (toConsole) {
      switch (level) {
        case "error":
          console.error(msg);
          break;
        case "warning":
          console.warn(msg);
          break;
        default:
          console.log(msg);
      }
    }
  }

  static error(err) {
    this.logger(err, "error");
  }

  static warn(msg) {
    this.logger(msg, "warning");
  }

  static log(msg) {
    this.logger(msg, "info");
  }
}
